module.exports = __webpack_public_path__ + "assets/img/vimeo-play.png";